import createIcon from '../../createIcon';

/**
 * @component @name Hardware
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggM0wxNSA2VjNIOUM2LjI0IDMgNCA1LjI0IDQgOEg5VjExSDE1VjhMMTggMTFIMjBWM0gxOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05IDEzVjIwQzkgMjAuNTUgOS40NSAyMSAxMCAyMUgxNEMxNC41NSAyMSAxNSAyMC41NSAxNSAyMFYxM0g5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hardware = createIcon('Hardware', [
  ['path', { d: 'M18 3L15 6V3H9C6.24 3 4 5.24 4 8H9V11H15V8L18 11H20V3H18Z', key: '1rb5zt' }],
  ['path', { d: 'M9 13V20C9 20.55 9.45 21 10 21H14C14.55 21 15 20.55 15 20V13H9Z', key: '1c1ll3' }],
]);

export default Hardware;
